module.exports = __webpack_public_path__ + "static/media/Search.fafca71d.svg";